(function () {
  const MOBILE_BREAKPOINT = window.matchMedia("(max-width: 749px)");
  const BUBBLE_SELECTOR = ".woot-widget-bubble";

  let applyScheduled = false;

  function getMobileDockHeight() {
    if (!MOBILE_BREAKPOINT.matches) return 0;
    const dock = document.getElementById("mobile-dock");
    return dock ? dock.offsetHeight : 0;
  }

  function getStickyCartHeight() {
    const stickyCart = document.querySelector("sticky-cart.is-visible");
    return stickyCart ? stickyCart.offsetHeight : 0;
  }

  function readPxVariable(name) {
    const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    const parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function getBottomOffset() {
    const dockOffset = readPxVariable("--mobile-dock-offset") || getMobileDockHeight();
    const stickyOffset = readPxVariable("--sticky-cart-offset") || getStickyCartHeight();
    const gap = readPxVariable("--chat-widget-bottom-gap") || 20;
    return dockOffset + stickyOffset + gap;
  }

  function applyChatOffset() {
    const stickyHeight = getStickyCartHeight();
    const bottom = getBottomOffset();

    document.documentElement.style.setProperty("--sticky-cart-offset", `${stickyHeight}px`);
    document.documentElement.style.setProperty("--chat-widget-bottom", `${bottom}px`);
    document.body.classList.toggle("sticky-cart-visible", stickyHeight > 0);

    let styleEl = document.getElementById("chat-widget-offset-dynamic");
    if (!styleEl) {
      styleEl = document.createElement("style");
      styleEl.id = "chat-widget-offset-dynamic";
      document.body.appendChild(styleEl);
    }
    styleEl.textContent = `html body .woot-widget-bubble { bottom: ${bottom}px !important; }`;

    document.querySelectorAll(BUBBLE_SELECTOR).forEach((bubble) => {
      bubble.style.setProperty("bottom", `${bottom}px`, "important");
    });
  }

  function scheduleApply() {
    if (applyScheduled) return;
    applyScheduled = true;
    requestAnimationFrame(() => {
      applyScheduled = false;
      applyChatOffset();
    });
  }

  function observeWidgetInjection() {
    new MutationObserver((mutations) => {
      const widgetAdded = mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some(
          (node) =>
            node.nodeType === 1 &&
            (node.matches?.(BUBBLE_SELECTOR) || node.querySelector?.(BUBBLE_SELECTOR)),
        ),
      );
      if (widgetAdded) scheduleApply();
    }).observe(document.body, { childList: true, subtree: true });
  }

  function observeStickyCart() {
    document.querySelectorAll("sticky-cart").forEach((stickyCart) => {
      new MutationObserver(scheduleApply).observe(stickyCart, {
        attributes: true,
        attributeFilter: ["class", "style"],
      });
      new ResizeObserver(scheduleApply).observe(stickyCart);
    });
  }

  function observeMobileDock() {
    const dock = document.getElementById("mobile-dock");
    if (!dock) return;
    new ResizeObserver(scheduleApply).observe(dock);
  }

  function init() {
    scheduleApply();
    observeWidgetInjection();
    observeStickyCart();
    observeMobileDock();

    document.addEventListener("floating-ui:offset-change", scheduleApply);
    document.addEventListener("chatwoot:ready", () => {
      scheduleApply();
      [100, 400, 1000, 2000].forEach((delay) => {
        window.setTimeout(scheduleApply, delay);
      });
    });

    MOBILE_BREAKPOINT.addEventListener("change", scheduleApply);
    window.addEventListener("resize", scheduleApply);
  }

  window.FloatingUiOffset = {
    update: scheduleApply,
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
